import * as React from 'react';
import { PROTOCOL_IFRAME } from 'pages/views/devices/utils/helper';

/**
 * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
 * This is an iframe that gets created when loading the devices page.
 * This iframe isn't visible but is used to be the target of all custom protocol links
 * when attempting to interact/open the Hub desktop application from Retail.
 * https://stackoverflow.com/a/29016818
 * The gist of the problem is that the alert prompted from clicking the custom protocol will
 * trigger the browser's `onbeforeunload` event, which in turn will kill our Ably WebSocket communication with the
 * desktop application.
 *
 * In other words... Don't touch this.
 * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
 */
const useProtocolIFrame = () => {
  React.useEffect(() => {
    if (document.getElementsByName(PROTOCOL_IFRAME).length) return;
    const { body } = document;
    const protocolFrame = document.createElement('iframe');
    protocolFrame.name = PROTOCOL_IFRAME;
    Object.assign(protocolFrame.style, {
      border: 'none',
      visibility: 'hidden',
      position: 'absolute',
      width: 0,
      height: 0,
    });
    body.appendChild(protocolFrame);

    // eslint-disable-next-line
    return () => {
      body.removeChild(protocolFrame);
    };
  }, []);
};

export { useProtocolIFrame };
